// removed by extract-text-webpack-plugin
module.exports = {"page":"KingstonConnect_page__3Oxg","description":"KingstonConnect_description__gzBb","icon":"KingstonConnect_icon__gUqD","buttonBox":"KingstonConnect_buttonBox__275w","loader":"KingstonConnect_loader__24KW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/KingstonConnect/styles/KingstonConnect.scss
// module id = 87
// module chunks = 0